import { createAction, props } from '@ngrx/store';

import { DecreeActions } from './decrees.const';

import { DecreeTabType, IDecreeDetailTabContent } from '~/decrees/decree-detail/decree-detail.types';
import { Menu, MenuItem } from '~/ui/detail/detail-action-button/detail-action-buttons.types';
import { DetailHeader } from '~/ui/detail/detail-header/detail-header.types';

export const fetchDecreeHeader = createAction(DecreeActions.fetchDecreeHeader, props<{ id: string }>());
export const fetchDecreeHeaderSuccess = createAction(
  DecreeActions.fetchDecreeHeaderSuccess,
  props<{
    id: string;
    data: DetailHeader;
  }>()
);
export const fetchDecreeHeaderFailure = createAction(
  DecreeActions.fetchDecreeHeaderFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeSidebar = createAction(DecreeActions.fetchDecreeSidebar, props<{ id: string }>());
export const fetchDecreeSidebarSuccess = createAction(
  DecreeActions.fetchDecreeSidebarSuccess,
  props<{
    id: string;
    data: Menu[];
  }>()
);
export const fetchDecreeSidebarFailure = createAction(
  DecreeActions.fetchDecreeSidebarFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreePrimaryActions = createAction(DecreeActions.fetchDecreePrimaryActions, props<{ id: string }>());
export const fetchDecreePrimaryActionsSuccess = createAction(
  DecreeActions.fetchDecreePrimaryActionsSuccess,
  props<{
    id: string;
    data: MenuItem[];
  }>()
);
export const fetchDecreePrimaryActionsFailure = createAction(
  DecreeActions.fetchDecreePrimaryActionsFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeGeneral = createAction(DecreeActions.fetchDecreeGeneral, props<{ id: string }>());
export const fetchDecreeGeneralSuccess = createAction(
  DecreeActions.fetchDecreeGeneralSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.DECREES>;
  }>()
);
export const fetchDecreeGeneralFailure = createAction(
  DecreeActions.fetchDecreeGeneralFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeAttachments = createAction(DecreeActions.fetchDecreeAttachments, props<{ id: string }>());
export const fetchDecreeAttachmentsSuccess = createAction(
  DecreeActions.fetchDecreeAttachmentsSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.ATTACHMENTS>;
  }>()
);
export const fetchDecreeAttachmentsFailure = createAction(
  DecreeActions.fetchDecreeAttachmentsFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeComments = createAction(DecreeActions.fetchDecreeComments, props<{ id: string }>());
export const fetchDecreeCommentsSuccess = createAction(
  DecreeActions.fetchDecreeCommentsSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.COMMENTS>;
  }>()
);
export const fetchDecreeCommentsFailure = createAction(
  DecreeActions.fetchDecreeCommentsFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeApprovals = createAction(DecreeActions.fetchDecreeApprovals, props<{ id: string }>());
export const fetchDecreeApprovalsSuccess = createAction(
  DecreeActions.fetchDecreeApprovalsSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.APPROVALS>;
  }>()
);
export const fetchDecreeApprovalsFailure = createAction(
  DecreeActions.fetchDecreeApprovalsFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeInfo = createAction(DecreeActions.fetchDecreeInfo, props<{ id: string }>());
export const fetchDecreeInfoSuccess = createAction(
  DecreeActions.fetchDecreeInfoSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.INFO>;
  }>()
);
export const fetchDecreeInfoFailure = createAction(
  DecreeActions.fetchDecreeInfoFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeRights = createAction(DecreeActions.fetchDecreeRights, props<{ id: string }>());
export const fetchDecreeRightsSuccess = createAction(
  DecreeActions.fetchDecreeRightsSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.RIGHTS>;
  }>()
);
export const fetchDecreeRightsFailure = createAction(
  DecreeActions.fetchDecreeRightsFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeFinancial = createAction(DecreeActions.fetchDecreeFinancial, props<{ id: string }>());
export const fetchDecreeFinancialSuccess = createAction(
  DecreeActions.fetchDecreeFinancialSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.FINANCIAL>;
  }>()
);
export const fetchDecreeFinancialFailure = createAction(
  DecreeActions.fetchDecreeFinancialFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeNotes = createAction(DecreeActions.fetchDecreeNotes, props<{ id: string }>());
export const fetchDecreeNotesSuccess = createAction(
  DecreeActions.fetchDecreeNotesSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.NOTES>;
  }>()
);
export const fetchDecreeNotesFailure = createAction(
  DecreeActions.fetchDecreeNotesFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeWebcast = createAction(DecreeActions.fetchDecreeWebcast, props<{ id: string }>());
export const fetchDecreeWebcastSuccess = createAction(
  DecreeActions.fetchDecreeWebcastSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.WEBCAST>;
  }>()
);
export const fetchDecreeWebcastFailure = createAction(
  DecreeActions.fetchDecreeWebcastFailure,
  props<{ id: string; error: any }>()
);

export const fetchDecreeImportedDecree = createAction(
  DecreeActions.fetchDecreeImportedDecree,
  props<{ decreeId: string; importId: string }>()
);
export const fetchDecreeImportedDecreeSuccess = createAction(
  DecreeActions.fetchDecreeImportedDecreeSuccess,
  props<{
    id: string;
    data: IDecreeDetailTabContent<DecreeTabType.IMPORTED_DECREE>;
  }>()
);
export const fetchDecreeImportedDecreeFailure = createAction(
  DecreeActions.fetchDecreeImportedDecreeFailure,
  props<{ id: string; error: any }>()
);
